import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "field" }

import { watch, reactive } from 'vue';
import useVuelidate from '@vuelidate/core';
import { helpers } from '@vuelidate/validators';
import { useToast } from 'primevue/usetoast';
import { PersonStores } from '@/store';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum';
import { ClassroomInterface } from '@/types/User';


export default /*@__PURE__*/_defineComponent({
  __name: 'ZoomClassroom',
  setup(__props) {

const toast = useToast();

const profileStore = PersonStores.useUserProfileStore();

const general: ClassroomInterface = reactive({
  zoom_classroom: undefined,
});

const urlRegex =
  /^(?:(?:(?:https):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

const safeUrl = (value: string): boolean => urlRegex.test(value);

const rules = {
  zoom_classroom: { safeUrl: helpers.withMessage('The value is not a valid URL address', safeUrl) },
};

const v$ = useVuelidate(rules, general);

const doToast = (error = false) => {
  toast.add({
    severity: error ? 'error' : 'success',
    summary: error ? 'Error' : 'Saved',
    detail: error ? 'The zoom classroom must be a valid URL.' : 'Classroom link has been saved',
    life: 5000,
  });
};

const onSave = async () => {
  if (!v$.value.$error) {
    resetDirty();
    await profileStore.updateGeneralInfo({ ...general });
    doToast();
  }
};

watch(
  () => profileStore.general?.zoom_classroom,
  (value) => {
    general.zoom_classroom = value;
  },
);

const resetDirty = () => {
  v$.value.$reset();
};

const onCancel = () => {
  general.zoom_classroom = profileStore.general?.zoom_classroom;
  resetDirty();
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FormCard = _resolveComponent("FormCard")!

  return (_openBlock(), _createBlock(_component_FormCard, {
    title: "Classroom",
    dirty: _unref(v$).$anyDirty,
    cancel: onCancel,
    save: onSave,
    "save-disabled": !_unref(can)([_unref(PERMISSIONS).PEOPLE_UPDATE]) || (_unref(v$).zoom_classroom.$anyDirty && _unref(v$).zoom_classroom.$invalid)
  }, {
    form: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_InputText, {
            id: "zoom_classroom",
            modelValue: _unref(v$).zoom_classroom.$model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).zoom_classroom.$model) = $event)),
            type: "url",
            class: _normalizeClass(["inputfield w-full", { 'p-invalid': _unref(v$).zoom_classroom.$invalid && _unref(v$).zoom_classroom.$dirty }]),
            disabled: !_unref(can)([_unref(PERMISSIONS).PEOPLE_UPDATE])
          }, null, 8, ["modelValue", "class", "disabled"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["dirty", "save-disabled"]))
}
}

})